import "./TeamList.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import TeamListComponentController from "./TeamListComponentController";

export default class TeamListComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = TeamListComponentController;
        this.templateUrl = "/App/Components/Site/Overview/TeamList/TeamList.html";
    }
}

module("mmManagePortal").component("mmSiteTeamList", new TeamListComponent());
